<template>
  <section>
    <h5>{{ $t('DASHBOARD.ONLINE_USERS')}}</h5>


      <ul class="user-profiles-list-small">
        <li v-for="item in items" :item="item" :key="item.id">

            <div class="user-avatar">
                <a href="#">
                    <b-img
                    :src="profileImage(item)"
                    height="50"
                    alt="placeholder"
                  ></b-img>
                </a>
            </div>

            <p class="user-name">
                 {{item.name}}
                <span>{{ $t('TEAM.USER_LATEST_ACTIVITY')}} {{ $moment(item.lastActivity) | moment("YYYY-MM-DD HH:mm") }}</span>
            </p>

        </li>
      </ul>     

  </section>
</template>
<script>
export default {
  data() {
    return {
      page: 0,
      limit: 3,
      items: [],
      totalItems: 0,
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {
    getPublished: function() {
      let self = this;
      this.$http
        .post(process.env.VUE_APP_BACKEND + "/team/list/online", {
          page: this.page,
          limit: this.limit,
          searchText: ''
        })
        .then(response => {
          self.items = response.data.items;
          self.totalItems = response.data.total;
        })
        .catch(() => {
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH_DATA"));
        });
    },
    profileImage(item) {
      if (item.imageExtension == null) {
        return "/img/default-avatar.png";
      } else {
        return process.env.VUE_APP_BACKEND + "/profile/image/" + item.id;
      }
    }
  },
  mounted: function() {
    this.getPublished();
  }
};
</script>
<style>
</style>
